import React, { createContext, useContext, useState } from "react";

import type {
  AdicionarUnidadeContextValue,
  NewUnitData,
} from "features/adicionar-unidade/types";

const AdicionarUnidadeContext = createContext(
  {} as AdicionarUnidadeContextValue
);

type ProviderProps = {
  children: React.ReactNode;
};

export const AdicionarUnidadeProvider = ({
  children,
}: ProviderProps): JSX.Element => {
  const [step, setStep] = useState(1);
  const [typeSelector, setTypeSelector] = useState("cep");
  const [condoZipCode, setCondoZipCode] = useState("");
  const [condoCode, setCondoCode] = useState("");
  const [externalUnitId, setExternalUnitId] = useState("");
  const [newUnitData, setNewUnitData] = useState<NewUnitData>(
    {} as NewUnitData
  );

  return (
    <AdicionarUnidadeContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        step,
        setStep,
        typeSelector,
        setTypeSelector,
        condoZipCode,
        setCondoZipCode,
        condoCode,
        setCondoCode,
        externalUnitId,
        setExternalUnitId,
        newUnitData,
        setNewUnitData,
      }}
    >
      {children}
    </AdicionarUnidadeContext.Provider>
  );
};

export function useAdicionarUnidade(): AdicionarUnidadeContextValue {
  return useContext(AdicionarUnidadeContext);
}
